export default function _pipeP(f, g) {
  return function () {
    var ctx = this;
    return f.apply(ctx, arguments).then(function (x) {
      return g.call(ctx, x);
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_pipeP.js
// module id = ../node_modules/ramda/es/internal/_pipeP.js
// module chunks = 5